import { IDynamicContent } from '@/modules/common/types';

export interface IGetInvestmentSuggestionsResponse {
  suggestions: IInvestmentSuggestionsList;
  partner: IPartner;
  athenaProductTransaction?: IAthenaProductTransaction;
}

export interface IInvestmentSuggestionsList {
  data: IInvestmentSuggestion[];
}

export interface IPartner {
  name: string;
  email: string;
}

export interface IInvestmentSuggestion {
  transactionId: string;
  portfolioApiId: string;
  portfolioName: string;
  type: IValueFomatted<string>;
  createdAt: IValueFomatted<string>;
  expiredAt: IValueFomatted<string>;
  amount: IValueFomatted;
  quantity: number;
}

export interface IValueFomatted<T = number, G = string> {
  value: T;
  formatted: G;
}

export interface IGetSuggestionDetailsResponse {
  transaction: ITransaction;
  portfolio: IPortfolio;
  agreements: IAgreements;
  athenaProductTransaction?: IAthenaProductTransaction;
}

export interface ITransaction {
  origin: string;
  destination: string;
  transactionId: string;
  portfolioApiId: string;
  direction: string;
  createdAt: IValueFomatted<string>;
  expiredAt: IValueFomatted<string>;
  amount: IValueFomatted;
  netAmount: IValueFomatted;
  type: string;
  products: IInvestmentProducts[];
}

export interface ProductInformartionWithDisclaimer {
  title: string;
  value: string;
  disclaimer: IDynamicContent[];
  action: string;
  formatted: string;
}

export interface IInvestmentProducts {
  productApiId: string;
  amount: IValueFomatted;
  apiId: string;
  productName: string;
  liquidation: string;
  portfolioShare: string;
  rebateCashbackAdministration: ProductInformartionWithDisclaimer;
  rebateCashbackPerformance: ProductInformartionWithDisclaimer;
  spread: ProductInformartionWithDisclaimer;
}

export interface IPortfolio {
  name: string;
  managementType: string;
  isVirtual: boolean;
  fee: ProductInformartionWithDisclaimer;
  allocations?: IAllocation[];
}

export interface IAllocation {
  percentage: IValueFomatted;
  type: IValueFomatted<string>;
}

export interface IAgreements {
  requestRisks: boolean;
  requestTerms: boolean;
}

export interface IGetSuggestionDetailsParams {
  transactionId: string;
  portfolioId: string;
}

export interface IPutInvestmentAgreementResponse {
  createdAt: string;
  createdBy: string;
  customerId: string;
  description: null;
  identifier: string;
  investmentType: string;
  partnerId: string;
  portfolioId: string;
  requestId: string;
  status: string;
  transactionId: string;
  unvalidatedAt: string;
  updatedAt: string;
  updatedBy: string;
  _id: string;
  productIds: string[];
}

export interface IPutInvestmentAgreementParams {
  transactionId: string;
  customerId: string;
  status: string;
  updatedBy: string;
  portfolioId?: string;
}

export enum EInstrumentType {
  Funds = 'funds',
  Bond = 'fixed-income',
  GovernmentBond = 'government-bond',
  FundPension = 'fund-pension',
  StructuredOperation = 'structured-operation',
  InitialPublicOffering = 'initial-public-offering'
}

export interface IAthenaProductTransaction {
  quantity: number;
  operationValue: IValueFomatted;
  expiredAt: IValueFomatted<string>;
  brokerageFee?: string;
  structuringFee?: string;
  coordinationFee?: string;
  distributionFee?: string;
  symbol: string;
  subtitle: string;
  warning: string;
  instrumentType: EInstrumentType;
}
